<template>
  <div class="modelReg">
    <div class="modelReg__grid">
    <div class="modelReg__goToBack">
      <button class="icon-pva__back" @click="goToBack" />
    </div>
    <div class="modelReg__title">
      <h3>{{ $t('modal.auth_modal_state.restore_password.title') }}</h3>
      <p>{{ $t('modal.auth_modal_state.restore_password.sub_title') }}</p>
    </div>
    <div class="modelReg__alertLoading" v-if="loader"></div>
    <div class="modelReg__alertError" v-if="errorMessage">{{ errorMessage }}</div>
    <div class="modelReg__alertSuccess" v-if="successMessage">{{ successMessage }}</div>
    <UForm class="modelReg__form">
      <UiPhoneInputInternational
        v-model="form.phone"
        :label="$t('modal.auth_modal_state.login.input_phone')"
        :error="v$.phone.$error"
        :errors="v$.phone.$errors"
        :show-error="v$.phone.$dirty"
        @change="v$.phone.$touch"
      />

      <UiButtonMain
        color="red"
        class="btn"
        size="xl"
        :label="$t('modal.auth_modal_state.restore_password.btn')"
        block
        type="submit"
        :disabled="v$.$invalid"
        @click.prevent="sendEmail"
      ></UiButtonMain>
    </UForm>
  </div>
  </div>
</template>

<script setup>
/* v8 ignore file */
import { onMounted, nextTick } from 'vue';
import apiAuth from '~/entities/auth';
import { useVuelidate } from '@vuelidate/core';
import { modalStateEnum } from '@shared/model';
import { useResponseStatusesState, useRulesForForm } from '@shared/lib';
import { useAuthStore } from '~/features/auth';
import { useUserProfileStore } from '@entities/user';

const storeAuth = useAuthStore();
const storeUserProfile = useUserProfileStore();
const { responseStatusesState } = useResponseStatusesState();
const { RulesForFormPhone } = useRulesForForm();
const props = defineProps({
  userData: {
    type: Object,
    required: true,
    default: {
      phone: '',
      email: '',
      password: '',
      confirmPassword: '',
      twoFA: '',
      codeFromEmail: '',
    },
  },
});
const form = ref({ ...props.userData });

const loader = ref(false);
const errorMessage = ref(null);
const successMessage = ref(null);
const { t } = useI18n();

const rules = computed(() => {
  return {
    phone: RulesForFormPhone(),
  };
});
const v$ = useVuelidate(rules, form);

onMounted(() => {
  if (storeAuth.isLoggedIn) {
    form.value.phone = storeUserProfile.getUser?.default_email;
  }
  nextTick(() => {
    v$.value.$reset();
  });
});

const sendEmail = () => {
  const params = {
    phone: form.value.phone,
  };
  v$.value.$validate();
  if (!v$.value.$error) {
    loader.value = true;
    apiAuth
      .forgotPassword(params)
      .then((data) => {
        const responseCode = data.code;
        successMessage.value = responseStatusesState[responseCode];

        setTimeout(() => {
          storeModal.stateAuthModal(modalStateEnum.RestorePasswordSuccessfully);
        }, 2000);
      })
      .catch((error) => {
        const responseCode = error.data.code || 5000;
        errorMessage.value = responseStatusesState[responseCode];
      })
      .finally(() => {
        loader.value = false;
        setTimeout(() => {
          errorMessage.value = null;
          successMessage.value = null;
        }, 6000);
      });
  }
};

const goToBack = () => {
          storeModal.stateAuthModal(storeModal.authModalStateOldStore);
};
</script>


